import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { http } from "../../../../utils/httpCommon";
import { useApiUrls } from "../../../useApiUrl";
import { useIsFeatureFlagEnabled } from "../../../../featureFlags/useIsFeatureFlagEnabled";
import { safeParsePartial } from "../../../../utils/zodSafeParse";

export const userGroupsKeys = {
  getUserGroups: (userId: string) => ["userGroups", userId],
};

const userGroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullish(),
  dateAssigned: z.date().nullish(),
  updatedBy: z.string().nullish(),
});
export type UserGroup = z.infer<typeof userGroupSchema>;

export const useGetUserGroups = (userId: string, enabled = true) => {
  const urls = useApiUrls();
  const isSafeParseEnabled = useIsFeatureFlagEnabled(
    "operations-5864-inbound-zod-parser-client"
  );

  return useQuery({
    enabled,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: userGroupsKeys.getUserGroups(userId),
    queryFn: async () => {
      const { data } = await http.get(urls.getUserGroups(userId));
      return isSafeParseEnabled
        ? safeParsePartial(userGroupSchema.array(), data, "useGetUserGroups")
        : userGroupSchema.array().parse(data);
    },
  });
};
